import { createStore } from "easy-peasy";
import model from "./models";

const store = createStore(model);

export default store;
